import { render, staticRenderFns } from "./create-po.vue?vue&type=template&id=2dcb24fc&"
import script from "./create-po.vue?vue&type=script&lang=js&"
export * from "./create-po.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports